import FilterJobSeekerList from "@Molecule/FilterJobSeekerList";
import Styles from "./styles.module.scss";
// import JobSeekersShowcase from "@Molecule/_jobSeekers/JobSeekersShowcase";
import { useEffect, useState } from "react";
import Icon from "@Atom/Icon";
import { useNavigate } from "react-router-dom";
import JobSeekersShowcase from "@Molecule/_jobSeekers/JobSeekersShowcase";

export default function TeamporaryHome({ options, showFilter, setShowFilter }) {
  const [isLoading, setIsloading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (options === null) {
      setIsloading(true);
    } else {
      setIsloading(false);
    }
  }, [options]);

  return (
    <div className={Styles.containerTemporary}>
      <div className={Styles.showcaseWrapper}>
        <JobSeekersShowcase />
      </div>

      <div className={Styles.search}>
        <FilterJobSeekerList
          options={options}
          isLoading={isLoading}
          showFilter={showFilter}
          setShowFilter={setShowFilter}
        />
      </div>
    </div>
  );
}
